<template>
    <b-overlay :show="submitting || updating || generalDeleting" rounded="sm">
    <div class="health-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="cancel-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
                <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                    <b-row>
                       
                        <b-col cols="6 mt-2">
                            <label class="mb-3">
                                <strong>{{$translate('month_year')}}<span class="red">*</span></strong>
                            </label>
                            <b-form-input 
                                type="month" 
                                id="input-month-year" 
                                v-custom-validation="$textRequired()" 
                                v-model="model.month_year"
                                required 
                                :placeholder="$translate('enter_month_year')" 
                            ></b-form-input>
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('activity_type') }}<span class="red">*</span></strong></label>
                          
                              <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')" 
                            v-model="model.type" 
                            :options="orderTypesArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('role') }}</strong></label>
                          
                              <multiselect id="input-role" :placeholder="$translate('select_role')" 
                            v-model="model.role" 
                            :options="roleArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('officers') }}</strong></label>
                          
                              <multiselect id="input-officers" :placeholder="$translate('select_officers')" 
                            v-model="model.officer" 
                            :options="officerArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                       
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('agents') }}</strong></label>
                          
                              <multiselect id="input-agents" :placeholder="$translate('select_agents')" 
                            v-model="model.agent" 
                            :options="agentArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('customer_segment') }}</strong></label>
                          
                              <multiselect id="input-customer_segment" :placeholder="$translate('select_customer_segment')" 
                            v-model="model.customer_segment" 
                            :options="segmentArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('interaction_type') }}</strong></label>
                          
                              <multiselect id="input-interaction_type" :placeholder="$translate('select_interaction_type')" 
                            v-model="model.interaction_type" 
                            :options="interaction_typeArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                       
                        
                        <b-col md="6" cols="12" class="mt-3  dd">
                          
                            <label for="input-type" class="mb-2"><strong>{{ $translate('customer_group') }}</strong></label>
                          
                              <multiselect id="input-customer_segment" :placeholder="$translate('select_customer_group')" 
                            v-model="model.customer_group" 
                            :options="customerGroupArray" 
                            :searchable="true"
                           
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                           
                            label="name" track-by="id" :close-on-select="true">
                               
                            </multiselect>
                          
                            
                        </b-col>
                       
                        <b-col cols="6 mt-2">
                            <label class="mb-3"><strong>{{$translate('target_no_of_activity')}}</strong></label>
                            <b-form-input type="number" id="input-target_no_of_activity" v-custom-validation="$textRequired()" v-model="model.target_no_of_activity"
                                 :placeholder="$translate('enter_target_no_of_activity')" ></b-form-input>
                        </b-col>
                          
                        <b-col cols="6 mt-2">
                            <label class="mb-3"><strong>{{$translate('target_total_value')}}</strong></label>
                            <b-form-input step="0.01" 
                            min="0" type="number" id="input-target_total_value" v-custom-validation="$textRequired()" v-model="model.target_total_value"
                                 :placeholder="$translate('enter_target_total_value')" ></b-form-input>
                        </b-col>
                        
                       
                      
                        
                      
                     
                        <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                            <b-button id="submit-btn" variant="info"  type="submit"  v-if="hasPermissionUpdate" class="btn-fw"
                                :disabled="submitting ? true : false">{{ submitLabel }}
                            </b-button>
                            <!-- <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button> -->
                            <!-- <b-button v-if="hasPermissionDelete && !isNew" @click="deletehealth()" class="float-right"
                                variant="delete-button" size="fw">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button id="delete-btn" v-if="!isNew && hasPermissionDelete" @click="delete_target()" class="float-right"
                            variant="delete-button" size="fw">
                            {{ $deleteLabel() }}
                        </b-button>
                            <b-button id="cancel-btn" variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                                {{ $cancelLabel() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import Multiselect from 'vue-multiselect'
export default {
    name: 'Targets',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    components: {
        Multiselect
    },
    data() {
        return {
            orderTypesArray: [],
            roleArray :[],
            officerArray : [],
            agentArray : [],
            segmentArray : [],
            interaction_typeArray : [],
            customerGroupArray : [],
            model: {
                id: 0,
                name: '',
                description:''
            },

            updating: false,

            submitting: false,
        }
    },
    computed: {
        componentName() { return this.$translate('targets') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_targets') : this.$translate('targets')
        },
        targets() {
            const targets = { ...this.$store.state.targets.targets }
          
          
            return targets
        },
      
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        officers() {
        return (this.$store.state.orders.drivers || []).map((x) => ({
            id: x.id,
            name: `${x.first_name} ${x.last_name}`.trim(),
        }));
        },
        roles() {
        return this.$store.state.roles.items;
        },
        categories() {
        return this.$store.state.requestCategory.categories;
        },

        interactionTypes() {
        return this.$store.state.interactionType.interaction_types;
        },
        customerAgents() {
        return this.$store.state.customerAgents.customer_agents.map(user => {
            return {
                ...user,
                name: `${user.first_name} ${user.last_name}`
            };
          });;
        },
        customerSegments() {
            return this.$store.state.customerSegments.customer_segments
        },
        customerGroups() {
            return this.$store.state.customerGroups.customer_groups
        },
       
    },
    async created() {
        await Promise.all([
          this.$store.dispatch("orderType/fetchAll"),
          this.$store.dispatch("roles/fetchAll"),
          this.$store.dispatch("orders/fetchDriversNew"),
          this.$store.dispatch("customerAgents/fetchAll"),
          this.$store.dispatch("interactionType/fetchAll"),
          this.$store.dispatch('customerSegments/fetchAll'),
          this.$store.dispatch('customerGroups/fetchAll')
        ]);
        
      
    },
    watch: {
        targets: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            this.$router.push('/ams/targets')
        },

        CreateOrUpdate() {
            this.submitting = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'targets/update' : 'targets/create',
                            this.model
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({ name: 'Targets' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({ name: 'Targets' })
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },

        async delete_target() {
            // Initializing key variables
            const model = { ...this.model,name : this.model.month_year }
            console.log('model------',model);
            const routes = {
                baseRoute: '/ams/targets',
                deleteRoute: 'targets/delete',
            }
            const notificationFields = {
                type: 'Targets',
                errorMsg: this.$translate('unable_target_alert'),
            }
            try {
                const result = await this.deleteItem(notificationFields, model, routes);
                if (result){
                    this.submitting = true;
                    this.$emit('success');
                }
            } catch (error) {
                console.error(error);
                this.doToast(this.$translate('error'), this.$translate('unable_alert'), 'danger');
            } finally {
                this.submitting = false;
            }
        },
    },
   async mounted() {


        this.orderTypesArray =    this.$store.getters["orderType/activityTypesByPermission"]; 
        this.roleArray = this.roles;
        this.officerArray = this.officers;
        this.agentArray = this.customerAgents;
        this.segmentArray = this.customerSegments;
        this.interaction_typeArray = this.interactionTypes;
        this.customerGroupArray = this.customerGroups;
        if (this.$route.params.id !== 0) {
           await  this.$store.dispatch('targets/fetchById', this.$route.params.id)
          
                    // Initialize an array to hold all filtered activity types
            let selectedActivityTypes = [];

            // Iterate through the activity types in the Vuex store
            this.$store.state.targets.targets.activity_types.forEach(activity => {
                // Filter the orderTypesArray for each activity based on activity_type_id
                let filtered_order_type = this.orderTypesArray.filter(order_type => order_type.id === activity.activity_type_id);
                
                // Concatenate the filtered activity types to the selectedActivityTypes array
                selectedActivityTypes = selectedActivityTypes.concat(filtered_order_type);
            });

            // Set the unique activity types in the model
            this.$set(this.model, 'type', selectedActivityTypes.length ? Array.from(new Set(selectedActivityTypes)) : []);

            // Initialize an array to hold all filtered agents
            let selectedAgents = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.agents.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.agentArray.filter(agent => agent.id === activity.agent_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedAgents = selectedAgents.concat(filtered_order_type);
            });

            // Set the unique agents in the model
            this.$set(this.model, 'agent', selectedAgents.length ? Array.from(new Set(selectedAgents)) : []);

            let selectedSegments = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.customer_segments.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.segmentArray.filter(segment => segment.id === activity.segment_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedSegments = selectedSegments.concat(filtered_order_type);
            });

            // Set the unique agents in the model
            this.$set(this.model, 'customer_segment', selectedSegments.length ? Array.from(new Set(selectedSegments)) : []);

            let selectedOfficers = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.officers.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.officerArray.filter(officer => officer.id === activity.officer_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedOfficers = selectedOfficers.concat(filtered_order_type);
            });
            console.log('officers are -------',selectedOfficers)
            // Set the unique agents in the model
            this.$set(this.model, 'officer', selectedOfficers.length ? Array.from(new Set(selectedOfficers)) : []);

            let selectedRoles = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.roles.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.roleArray.filter(role =>role.id === activity.role_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedRoles = selectedRoles.concat(filtered_order_type);
            });

            // Set the unique agents in the model
            this.$set(this.model, 'role', selectedRoles.length ? Array.from(new Set(selectedRoles)) : []);

            let selectedInteractionTypes = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.interaction_types.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.interaction_typeArray.filter(type =>type.id === activity.interaction_type_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedInteractionTypes = selectedInteractionTypes.concat(filtered_order_type);
            });

            // Set the unique agents in the model
            this.$set(this.model, 'interaction_type', selectedInteractionTypes.length ? Array.from(new Set(selectedInteractionTypes)) : []);


            let selectedCustomerGroups = [];

            // Iterate through the agents in the Vuex store
            this.$store.state.targets.targets.customer_groups.forEach(activity => {
                // Filter the agentArray for each agent based on agent_id
                let filtered_order_type = this.customerGroupArray.filter(type =>type.id === activity.customer_group_id);
                
                // Concatenate the filtered agents to the selectedAgents array
                selectedCustomerGroups = selectedCustomerGroups.concat(filtered_order_type);
            });

            // Set the unique agents in the model
            this.$set(this.model, 'customer_group', selectedCustomerGroups.length ? Array.from(new Set(selectedCustomerGroups)) : []);
        }
       
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>